function CriterioSelecaoPanel({
  inscricao,
  formatCriterioSelecao,
  getCriterioKey,
  getCriterioInfo,
}) {
  const key = getCriterioKey(inscricao);
  const docs = getCriterioInfo(key);

  return (
    <>
      <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
        Critério de Seleção
      </h5>
      <div>
        <div style={{ marginBottom: 8 }}>
          <b style={{ color: "black" }}>Critério: </b>
          <span>{formatCriterioSelecao(key)}</span>
        </div>
        <div style={{ marginTop: 8 }}>
          <b style={{ color: "black" }}>Documentos necessários: </b>
          <div style={{ marginTop: 6 }}>
            {docs.length > 0 ? (
              <ul style={{ paddingLeft: 18 }}>
                {docs.map((d, i) => (
                  <li key={`crit-doc-${i}`}>{d}</li>
                ))}
              </ul>
            ) : (
              <span>-</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default CriterioSelecaoPanel;
